module.exports = __webpack_public_path__ + "p8_img2.jpg?37d7616a1368521ab4335b5a8fd4b01d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img2.jpg
// module id = 121
// module chunks = 0